import { Dispatch, useEffect } from 'react';
import ConfigState from '../config/state/config-state';
import Action from '../state/action';
import ThemeConfig from '../themes/theme-config';

const useTheme = (config: ConfigState, dispatch: Dispatch<Action>, themeConfig?: ThemeConfig) => {
  useEffect(() => {
    if (config.type === 'parsed') {
      dispatch({
        type: 'theme-config',
        themedConfig: themeConfig || {},
      });
    }
  }, [config.type]);
};

export default useTheme;
